import { Edge, MarkerType } from 'reactflow';

const to_learner_style = (direction: string) => { return {
    data: { direction: direction, intensity: 30, animated: true }, 
    style: { stroke: '#000000', strokeWidth: 2 },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 12,
      height: 12,
      color: '#000000',
    },
}}

const from_learner_style = (direction: string) => { return {
    data: { direction: direction, intensity: 30, animated: true }, 
    style: { stroke: '#ff0000', strokeWidth: 2 },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 12,
      height: 12,
      color: '#ff0000',
    },
}}

const non_learner_vertical_style = (direction: string) => { return {
  data: { direction: direction, intensity: 15, animated: true }, 
  style: { stroke: '#333333', strokeWidth: 1.8 },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 12,
    height: 12,
    color: '#000000',
  },
}}

const learner_vertical_style = (direction: string) => { return {
  data: { direction: direction, intensity: 15, animated: true }, 
  style: { stroke: '#ff0000', strokeWidth: 1.8 },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 12,
    height: 12,
    color: '#ff0000',
  },
}}


export const edges: Edge[] = [
  // Vertical connections within columns
  // {
  //   id: 'teacher-vertical',
  //   source: 'teacher-concepts',
  //   sourceHandle: 'source-bottom',
  //   target: 'learning-environment',
  //   targetHandle: 'target-top',
  //   type: 'bezier',
  //   style: { stroke: '#000000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#000000',
  //   },
  // },
  // {
  //   id: 'learning-vertical',
  //   source: 'learning-concepts',
  //   sourceHandle: 'source-bottom',
  //   target: 'learning-practice',
  //   targetHandle: 'target-top',
  //   type: 'bezier',
  //   style: { stroke: '#ff0000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#ff0000',
  //   },
  // },
  // {
  //   id: 'peer-vertical',
  //   source: 'peer-concepts',
  //   sourceHandle: 'source-bottom',
  //   target: 'peer-practice',
  //   targetHandle: 'target-top',
  //   type: 'bezier',
  //   style: { stroke: '#ff0000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#ff0000',
  //   },
  // },
  
  // top-left
  {
    id: 'teacher-concepts-to-learner-concepts',
    source: 'teacher-concepts',
    sourceHandle: 'source-top',
    target: 'learner-concepts',
    targetHandle: 'target-top',
    type: 'customEdge',
    ...to_learner_style('up'),
  },
  {
    id: 'learner-concepts-to-teacher-concepts',
    source: 'learner-concepts',
    sourceHandle: 'source-bottom',
    target: 'teacher-concepts',
    targetHandle: 'target-bottom',
    type: 'customEdge',
    ...from_learner_style('down'),
  },

  // top-right
  {
    id: 'learner-concepts-to-peer-concepts',
    source: 'learner-concepts',
    sourceHandle: 'source-top',
    target: 'peer-concepts',
    targetHandle: 'target-top',
    type: 'customEdge',
    ...from_learner_style('up'),
  },
  {
    id: 'peer-concepts-to-learner-concepts',
    source: 'peer-concepts',
    sourceHandle: 'source-bottom',
    target: 'learner-concepts',
    targetHandle: 'target-bottom',
    type: 'customEdge',
    ...to_learner_style('down'),
  },

  // bottom-left
  {
    id: 'learning-environment-to-learner-practice',
    source: 'learning-environment',
    sourceHandle: 'source-top',
    target: 'learner-practice',
    targetHandle: 'target-top',
    type: 'customEdge',
    ...to_learner_style('up'),
  },
  {
    id: 'learner-practice-to-learning-environment',
    source: 'learner-practice',
    sourceHandle: 'source-bottom',
    target: 'learning-environment',
    targetHandle: 'target-bottom',
    type: 'customEdge',
    ...from_learner_style('down'),
  },

  // bottom-right
  {
    id: 'learner-practice-to-peer-practice',
    source: 'learner-practice',
    sourceHandle: 'source-top',
    target: 'peer-practice',
    targetHandle: 'target-top',
    type: 'customEdge',
    ...from_learner_style('up'),
  },
  {
    id: 'peer-practice-to-learner-practice',
    source: 'peer-practice',
    sourceHandle: 'source-bottom',
    target: 'learner-practice',
    targetHandle: 'target-bottom',
    type: 'customEdge',
    ...to_learner_style('down'),
  },

  // vertical
  // column1
  {
    id: 'learning-environment-to-teacher-concepts',
    source: 'learning-environment',
    sourceHandle: 'source-left',
    target: 'teacher-concepts',
    targetHandle: 'target-left',
    type: 'customEdge',
    ...non_learner_vertical_style('left'),
  },
  {
    id: 'teacher-concepts-to-learning-environment',
    source: 'teacher-concepts',
    sourceHandle: 'source-right',
    target: 'learning-environment',
    targetHandle: 'target-right',
    type: 'customEdge',
    ...non_learner_vertical_style('right'),
  },
  // column2
  {
    id: 'learner-practice-to-learner-concepts',
    source: 'learner-practice',
    sourceHandle: 'source-left',
    target: 'learner-concepts',
    targetHandle: 'target-left',
    type: 'customEdge',
    ...learner_vertical_style('left'),
  },
  {
    id: 'learner-concepts-to-learner-practice',
    source: 'learner-concepts',
    sourceHandle: 'source-right',
    target: 'learner-practice',
    targetHandle: 'target-right',
    type: 'customEdge',
    ...learner_vertical_style('right'),
  },
  // column3
  {
    id: 'peer-practice-to-peer-concepts',
    source: 'peer-practice',
    sourceHandle: 'source-left',
    target: 'peer-concepts',
    targetHandle: 'target-left',
    type: 'customEdge',
    ...non_learner_vertical_style('left'),
  },
  {
    id: 'peer-concepts-to-peer-practice',
    source: 'peer-concepts',
    sourceHandle: 'source-right',
    target: 'peer-practice',
    targetHandle: 'target-right',
    type: 'customEdge',
    ...non_learner_vertical_style('right'),
  },
  
  // {
  //   id: 'learning-to-peer',
  //   source: 'learning-concepts',
  //   sourceHandle: 'source-top',
  //   target: 'peer-concepts',
  //   targetHandle: 'target-top',
  //   type: 'bezier',
  //   style: { stroke: '#ff0000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#ff0000',
  //   },
  // },
  // {
  //   id: 'teacher-env-to-learning-practice',
  //   source: 'learning-environment',
  //   sourceHandle: 'source-bottom',
  //   target: 'learning-practice',
  //   targetHandle: 'target-bottom',
  //   type: 'bezier',
  //   style: { stroke: '#000000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#000000',
  //   },
  // },
  // {
  //   id: 'learning-practice-to-peer-practice',
  //   source: 'learning-practice',
  //   sourceHandle: 'source-bottom',
  //   target: 'peer-practice',
  //   targetHandle: 'target-bottom',
  //   type: 'bezier',
  //   style: { stroke: '#ff0000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#ff0000',
  //   },
  // },
  
  // Additional bottom-to-bottom connections
  // {
  //   id: 'teacher-env-to-learning-practice-bottom',
  //   source: 'learning-environment',
  //   sourceHandle: 'source-bottom',
  //   target: 'learning-practice',
  //   targetHandle: 'target-bottom',
  //   type: 'bezier',
  //   style: { stroke: '#000000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#000000',
  //   },
  // },
  // {
  //   id: 'learning-practice-to-peer-practice-bottom',
  //   source: 'learning-practice',
  //   sourceHandle: 'source-bottom',
  //   target: 'peer-practice',
  //   targetHandle: 'target-bottom',
  //   type: 'bezier',
  //   style: { stroke: '#ff0000', strokeWidth: 4 },
  //   markerEnd: {
  //     type: MarkerType.ArrowClosed,
  //     width: 20,
  //     height: 20,
  //     color: '#ff0000',
  //   },
  // },
];
